import * as React from "react";
function SvgDpCloseCross(props) {
  return <svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" {...props}><g fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round" stroke="currentColor" strokeWidth={5}><path d="M8 8l6.41 6.41L40 40M40 8l-6.41 6.41L8 40" /></g></svg>;
}
export default __webpack_public_path__ + "main/assets/dp-close-cross-31863031.svg";
export { SvgDpCloseCross as ReactComponent };